import flash from '@shared/flash';

export const responseDataErrorHandler = error => {
  if (error?.response?.data?.error) {
    flash({ error: error.response.data.error });
  } else {
    throw error;
  }
};